import { render, staticRenderFns } from "./ClientsList.vue?vue&type=template&id=b3fa8c9c&"
import script from "./ClientsList.vue?vue&type=script&lang=js&"
export * from "./ClientsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports